import { render, staticRenderFns } from "./batchSettingsList.vue?vue&type=template&id=5f89d6fa&scoped=true&"
import script from "./batchSettingsList.vue?vue&type=script&lang=js&"
export * from "./batchSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./batchSettingsList.vue?vue&type=style&index=0&id=5f89d6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89d6fa",
  null
  
)

component.options.__file = "batchSettingsList.vue"
export default component.exports